// Time constants in milliseconds
const SECOND = 1000
const MINUTE = 60 * SECOND
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR
const WEEK = 7 * DAY
const MONTH = 30 * DAY
const YEAR = 365 * DAY

export const TIMING = {
  SECOND,
  MINUTE,
  HOUR,
  DAY,
  WEEK,
  MONTH,
  YEAR,
} as const

export const CACHE_CONFIG = {
  // React Query staleTime - how long data is considered fresh
  STALE_TIME: {
    GROUPS: 10 * MINUTE,
    DEALERSHIPS: 10 * MINUTE,
    STATS: 5 * MINUTE,
  },
  
  // React Query gcTime - how long unused data stays in cache before garbage collection
  GC_TIME: {
    DEFAULT: 30 * MINUTE,
  },
  
  // Retry configuration
  RETRY_COUNT: 2,
} as const

export const DASHBOARD_CONSTANTS = {
  // Pagination
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
  
  // Refresh intervals
  AUTO_REFRESH_INTERVAL: 5 * MINUTE,
  
  // Local storage keys
  STORAGE_KEYS: {
    SELECTED_ENTITY: 'selectedDealershipEntity',
    SELECTED_DEALERSHIP_ID: 'selectedDealershipId',
    AUTH_TOKEN: 'auth_token',
  },
} as const

